const LoadingState = {
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  COMPLETE: 'COMPLETE',
  PARTIAL: 'PARTIAL',
};
// eslint-disable-next-line import/prefer-default-export
export { LoadingState };
